<form>
  <title mat-dialog-title>{{ 'incidentManagement.dialogs.addMedia.title' | t }}</title>
  <mat-dialog-content>
    <p>{{ 'incidentManagement.dialogs.addMedia.description' | t }}</p>
    <div class="form-container">
      <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      <button
        mat-icon-button
        class="addNewCaseButton"
        (click)="addNewIncident()"
        color="accent"
        [matTooltip]="'incidentManagement.dialogs.addMedia.createNewCase' | t"
        matTooltipPosition="left"
      >
        <sn-icon>add</sn-icon>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="danger" type="button" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button
      mat-button
      color="success"
      type="button"
      (click)="submit(false)"
      *ngIf="!this.data.needsUpload"
    >
      {{ 'common.send' | t }}
    </button>
    <button
      mat-button
      color="success"
      type="button"
      (click)="submit(false)"
      *ngIf="this.data.needsUpload"
    >
      {{ 'common.save' | t }}
    </button>
    <button
      mat-button
      color="success"
      type="button"
      (click)="submit(true)"
      *ngIf="this.data.needsUpload"
    >
      {{ 'common.saveAndClose' | t }}
    </button>
  </mat-dialog-actions>
</form>
